const performanceDashboard = {
  supplierSelector: {
    label: 'Flotte auswählen:',
  },
};

export default performanceDashboard;
